import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) {}

  showError(message: string, title?: string, options?: { timeOut?: number; closeButton?: boolean; progressBar?: boolean }): void {
    this.toastr.error(message, title || '', {
      timeOut: options?.timeOut ?? 5000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true
    });
  }

  showSuccess(message: string, title?: string, options?: { timeOut?: number; closeButton?: boolean; progressBar?: boolean }): void {
    this.toastr.success(message, title || '', {
      timeOut: options?.timeOut ?? 3000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true
    });
  }

  showInfo(message: string, title?: string, options?: { timeOut?: number; closeButton?: boolean; progressBar?: boolean }): void {
    this.toastr.info(message, title || '', {
      timeOut: options?.timeOut ?? 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true
    });
  }

  showWarning(message: string, title?: string, options?: { timeOut?: number; closeButton?: boolean; progressBar?: boolean }): void {
    this.toastr.warning(message, title || '', {
      timeOut: options?.timeOut ?? 4000,
      closeButton: options?.closeButton ?? true,
      progressBar: options?.progressBar ?? true
    });
  }
}
